import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ROME_UI_LOADER_CONFIG_TOKEN } from '../config/rome-ui-loader-config.token';
import { RomeUiLoaderService } from '../services/rome-ui-loader.service';
import { RomeEndpointConfigItem, RomeUiLoaderConfig } from '../utils/interfaces';

function getRomeEndpointConfig(url: string, includedEndpoints: Array<RomeEndpointConfigItem>): RomeEndpointConfigItem {
  return includedEndpoints.find((progressBarIncludedEndpoint) => url === progressBarIncludedEndpoint.url);
}

@Injectable()
export class RomeUiLoaderHttpInterceptor implements HttpInterceptor {
  private count: number;

  constructor(
    @Optional() @Inject(ROME_UI_LOADER_CONFIG_TOKEN) private readonly config: RomeUiLoaderConfig,
    private readonly romeUiLoaderService: RomeUiLoaderService
  ) {
    this.count = 0;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isExcluded = this.config.EXCLUDED_ENDPOINTS.indexOf(req.url) !== -1;
    const customRomeEndpointConfig = getRomeEndpointConfig(req.url, this.config.CUSTOM_ENDPOINTS);

    if (isExcluded) {
      return next.handle(req);
    }

    if (customRomeEndpointConfig) {
      this.romeUiLoaderService.setCustomUiLoaderConfigItem(customRomeEndpointConfig);
    }

    this.count++;
    this.romeUiLoaderService.start();

    return next.handle(req).pipe(
      finalize(() => {
        this.count--;
        if (this.count === 0) {
          this.romeUiLoaderService.stop();
          this.romeUiLoaderService.setCustomUiLoaderConfigItem(undefined);
        }
      })
    );
  }
}
